import { http } from '../../config/axios'

export default function postConsultaLote(consultaLote: any): Promise<string> {
  return http
    .post('api/consultalote', consultaLote)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro post consultaLote', error)
      throw Error(error.response.data)
    })
}
